module.exports = __webpack_public_path__ + "fonts/Cormorant-Regular.45c3e0cc.ttf";